"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[510],{

/***/ 12433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OD": function() { return /* binding */ Lozenge; }
/* harmony export */ });
/* unused harmony exports rotationClasses, sizeClasses */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51123);



var rotationClasses = {
    1: "rotate-[30deg]",
    2: "rotate-[60deg]",
    3: "rotate-[90deg]",
    4: "rotate-[120deg]",
    5: "rotate-[150deg]",
    6: "rotate-[180deg]",
    7: "rotate-[210deg]",
    8: "rotate-[240deg]",
    9: "rotate-[270deg]",
    10: "rotate-[300deg]",
    11: "rotate-[330deg]",
    12: "rotate-[360deg]"
};
var sizeClasses = {
    sm: "w-[52px] h-[92px]",
    md: "w-[82px] h-[147px]",
    lg: "w-[117px] h-[209px]",
    xl: "w-[141px] h-[252px]"
};
var Lozenge = function(param) {
    var color = param.color, size = param.size, rotation = param.rotation, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_colors__WEBPACK_IMPORTED_MODULE_2__/* .backgroundClasses */ .b0[color], sizeClasses[size], rotationClasses[rotation], "scale-[40%] tablet:scale-[60%] lg:scale-75 xl:scale-90 2xl:scale-100", "origin-center block rounded-full", className)
    });
};


/***/ }),

/***/ 7693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ One; }
/* harmony export */ });
/* unused harmony export rotationClasses */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


var FILES = {
    "brand-base": "/decorations/one-brand-base.svg",
    "blue-base": "/decorations/one-blue-base.svg",
    "green-base": "/decorations/one-green-base.svg",
    "lilac-base": "/decorations/one-lilac-base.svg",
    "coral-base": "/decorations/one-coral-base.svg"
};
var rotationClasses = {
    up: "rotate-[15deg]",
    down: "rotate-[205deg]"
};
var One = function(param) {
    var _color = param.color, color = _color === void 0 ? "brand-base" : _color, _direction = param.direction, direction = _direction === void 0 ? "up" : _direction, className = param.className;
    if (!color || !FILES[color]) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        src: FILES[color],
        alt: "",
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(rotationClasses[direction], className)
    });
};


/***/ }),

/***/ 20034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Slider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67573);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57361);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30719);
/* harmony import */ var _context_PageContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43470);
/* harmony import */ var _images_IconLoader__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64162);










var controlsColorClasses = {
    white: "border-white text-white disabled:bg-white/10 disabled:border-white/0 disabled:text-white/75",
    "action-base": "border-action-base text-action-base disabled:bg-neutral-95 disabled:border-neutral-95 disabled:text-neutral-50"
};
var Slider = function(param) {
    var slides = param.slides, columns = param.columns, _gap = param.gap, gap = _gap === void 0 ? 0 : _gap, controlsColor = param.controlsColor, slideStyle = param.slideStyle, className = param.className, slideClassName = param.slideClassName;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_context_PageContext__WEBPACK_IMPORTED_MODULE_7__/* .PageContext */ .z), config = ref.config, locale = ref.locale;
    var translations = config.translations;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), prevEl = ref1[0], setPrevEl = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), nextEl = ref2[0], setNextEl = ref2[1];
    if (!(slides === null || slides === void 0 ? void 0 : slides.filter(Boolean).length)) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("relative", className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .Swiper */ .tq, {
                spaceBetween: gap,
                slidesPerView: 1,
                // slidesPerGroup={columns} // this sort of breaks dragging behaviour, removing it for now
                grabCursor: !(slides === null || slides === void 0 ? void 0 : slides.some(function(param) {
                    var props = param.props;
                    return props.href;
                })),
                // centeredSlides={true}
                breakpoints: {
                    640: {
                        slidesPerView: 2
                    },
                    768: {
                        slidesPerView: 3
                    },
                    1024: {
                        slidesPerView: columns
                    }
                },
                modules: [
                    swiper__WEBPACK_IMPORTED_MODULE_3__/* .Mousewheel */ .Gk,
                    swiper__WEBPACK_IMPORTED_MODULE_3__/* .Keyboard */ .N1,
                    swiper__WEBPACK_IMPORTED_MODULE_3__/* .Navigation */ .W_
                ],
                simulateTouch: true,
                // preventClicks={false}
                // preventClicksPropagation={false}
                navigation: {
                    prevEl: prevEl,
                    nextEl: nextEl
                },
                // autoHeight={true}
                keyboard: {
                    enabled: true
                },
                // pagination={{
                //   clickable: true,
                //   type: 'bullets',
                // }}
                mousewheel: {
                    forceToAxis: true
                },
                children: slides === null || slides === void 0 ? void 0 : slides.filter(Boolean).map(function(slide, n) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .SwiperSlide */ .o5, {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("self-stretch", slideClassName),
                        style: slideStyle,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "h-full select-none",
                            children: slide
                        })
                    }, n);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex justify-end gap-3",
                children: [
                    "prev",
                    "next"
                ].map(function(direction) {
                    var ref, ref1;
                    var _obj;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                        type: "button",
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("border-2 rounded-full flex items-center justify-center w-10 h-10 transition-colors", controlsColorClasses[controlsColor || "action-base"]),
                        ref: function(node) {
                            return direction === "prev" ? setPrevEl(node) : setNextEl(node);
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "sr-only",
                                children: direction === "prev" ? translations === null || translations === void 0 ? void 0 : (ref = translations.next_slide) === null || ref === void 0 ? void 0 : ref[locale] : translations === null || translations === void 0 ? void 0 : (ref1 = translations.previous_slide) === null || ref1 === void 0 ? void 0 : ref1[locale]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_images_IconLoader__WEBPACK_IMPORTED_MODULE_8__/* .IconLoader */ .p, {
                                icon: "chevron",
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("w-5 h-5", (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, "rotate-90", direction === "prev"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, "-rotate-90", direction === "next"), _obj))
                            })
                        ]
                    }, direction);
                })
            })
        ]
    });
};


/***/ }),

/***/ 90231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* unused harmony export ButtonMemo */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67573);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _helpers_sitemap_isInternalLink__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49853);
/* harmony import */ var _images_IconLoader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64162);
/* harmony import */ var _loaders_Spinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58998);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76609);










var variantClasses = {
    primary: "pyxis-btn-primary",
    secondary: "pyxis-btn-secondary",
    tertiary: "pyxis-btn-tertiary",
    brand: "pyxis-btn-brand",
    ghost: "pyxis-btn-ghost",
    white: "pyxis-btn-white"
};
var sizeClasses = {
    sm: "pyxis-btn-small",
    md: "pyxis-btn-medium",
    lg: "pyxis-btn-large",
    xl: "pyxis-btn-huge"
};
var iconSizeClasses = {
    sm: "w-4 h-4",
    md: "w-4 h-4",
    lg: "w-4 h-4",
    xl: "w-4 h-4"
};
var iconOnlySizeClasses = {
    sm: "w-10 h-10 md:w-10 md:h-10",
    md: "w-10 h-10 md:w-11 md:h-11",
    lg: "w-10 h-10 md:w-11 md:h-11",
    xl: "w-10 h-10 md:w-11 md:h-11"
};
var Button = function(props) {
    if ((0,_helpers_sitemap_isInternalLink__WEBPACK_IMPORTED_MODULE_6__/* .isInternalLink */ .F)(props.href)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_5__/* .Link */ .r, {
            href: props.href,
            locale: props.language,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonInner, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
                as: "span"
            }))
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonInner, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props));
};
var ButtonMemo = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.memo(Button)));
var ButtonInner = function(param) {
    var _as = param.as, as = _as === void 0 ? "a" : _as, _label = param.label, label = _label === void 0 ? "" : _label, href = param.href, onClick = param.onClick, target = param.target, _variant = param.variant, variant = _variant === void 0 ? "primary" : _variant, _size = param.size, size = _size === void 0 ? "lg" : _size, icon = param.icon, _iconPosition = param.iconPosition, iconPosition = _iconPosition === void 0 ? "after" : _iconPosition, _compact = param.compact, compact = _compact === void 0 ? false : _compact, ariaLabel = param.ariaLabel, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _loading = param.loading, loading = _loading === void 0 ? false : _loading, _download = param.download, download = _download === void 0 ? false : _download, _hideLabel = param.hideLabel, hideLabel = _hideLabel === void 0 ? false : _hideLabel, _stretch = param.stretch, stretch = _stretch === void 0 ? false : _stretch, _alt = param.alt, alt = _alt === void 0 ? false : _alt;
    var Element = as === "submit" ? "button" : as;
    var props = {
        type: null,
        href: null,
        target: null,
        download: null,
        title: null,
        disabled: null
    };
    if (target === "_blank") {
        icon = "external-link";
        iconPosition = "after";
    }
    if (hideLabel) {
        ariaLabel = props.title = label;
        label = "";
    }
    label = label || "";
    iconPosition = iconPosition || "after";
    // prevent orphan icon by adding first / last word to icon
    var labelWords = label === null || label === void 0 ? void 0 : label.split(" ");
    if (as === "button") {
        props.type = "button";
    }
    if (as === "submit") {
        props.type = "button";
    }
    if (as === "a") {
        props.href = href;
        props.target = target;
    }
    if (download) {
        var ref;
        props.download = true;
        if (((ref = props.href) === null || ref === void 0 ? void 0 : ref.indexOf(".sanity.io")) > -1) props.href = "".concat(props.href, "?dl");
    }
    if (disabled) {
        props.disabled = "disabled";
    }
    var handleClick = function(e) {
        return disabled ? function() {} : onClick ? onClick(e) : function() {};
    };
    var ButtonIcon = icon ? function(param) {
        var wordBefore = param.wordBefore, wordAfter = param.wordAfter;
        var _obj;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            className: "whitespace-nowrap break-all",
            children: [
                wordBefore && " ".concat(wordBefore),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("inline text-current", iconSizeClasses[size], (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, "mr-2", wordAfter), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, "ml-2", wordBefore), _obj)),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_images_IconLoader__WEBPACK_IMPORTED_MODULE_3__/* .IconLoader */ .p, {
                        icon: icon,
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("inline-block translate-y-1", iconSizeClasses[size])
                    })
                }),
                wordAfter && "".concat(wordAfter, " ")
            ]
        });
    } : null;
    var _obj;
    var sharedClasses = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, "pyxis-btn", true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, sizeClasses[size], true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, variantClasses[variant], true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, "pyxis-btn-alt", alt), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, "inline-flex items-center justify-center", !stretch), _obj);
    // icon only button
    if (!(label === null || label === void 0 ? void 0 : label.trim().length)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Element, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
            "aria-label": ariaLabel || label,
            onClick: handleClick,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(sharedClasses, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, iconOnlySizeClasses[size], !compact)),
                children: [
                    ButtonIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonIcon, {}),
                    loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonLoader, {})
                ]
            })
        }));
    }
    // icon + text button
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Element, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
        "aria-label": ariaLabel || label,
        onClick: handleClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(sharedClasses, sizeClasses[size], (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, "w-full flex", stretch)),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "text-left break-words",
                children: ButtonIcon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        ButtonIcon && iconPosition === "before" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonIcon, {
                            wordAfter: labelWords[0]
                        }),
                        iconPosition === "before" ? labelWords.slice(1).join(" ") : labelWords.slice(0, -1).join(" "),
                        ButtonIcon && iconPosition === "after" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonIcon, {
                            wordBefore: labelWords[labelWords.length - 1]
                        }),
                        loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonLoader, {})
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "flex",
                    children: [
                        label,
                        loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonLoader, {})
                    ]
                })
            })
        })
    }));
};
var ButtonLoader = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "h-5 w-5 inline-flex self-center align-middle ml-2 -mb-1",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_loaders_Spinner__WEBPACK_IMPORTED_MODULE_4__/* .Spinner */ .$, {})
    });
};


/***/ }),

/***/ 12901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ ButtonGroup; }
/* harmony export */ });
/* unused harmony export ButtonGroupMemo */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67573);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14251);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90231);






var ButtonGroup = function(param) {
    var items = param.items, direction = param.direction, stretch = param.stretch, align = param.align, className = param.className;
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex-wrap gap-3 md:gap-4", (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "flex-col", direction === "vertical"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "inline-flex", !stretch), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "flex w-full", stretch), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "justify-start", direction === "horizontal" && align === "left"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "justify-center", direction === "horizontal" && align === "center"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "justify-end", direction === "horizontal" && align === "right"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "items-start", direction === "vertical" && align === "left"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "items-center", direction === "vertical" && align === "center"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "items-end", direction === "vertical" && align === "right"), _obj), className),
        children: items === null || items === void 0 ? void 0 : items.map(function(item) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex-shrink-0 max-w-full", (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, "w-full", item.stretch)),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, item))
            }, item.label);
        })
    });
};
var ButtonGroupMemo = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.memo(ButtonGroup)));


/***/ }),

/***/ 55237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "xv": function() { return /* binding */ Text; }
/* harmony export */ });
/* unused harmony exports ALIGN_OPTIONS, SIZE_OPTIONS, FONT_OPTIONS, TextMemo */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67573);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51123);
/* harmony import */ var _helpers_utils_object__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21236);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23302);







var ALIGN_OPTIONS = (0,_helpers_utils_object__WEBPACK_IMPORTED_MODULE_5__/* .pick */ .e)(_types__WEBPACK_IMPORTED_MODULE_4__/* .ALIGNMENTS */ .Eu, "left", "center", "right", "auto");
var SIZE_OPTIONS = (0,_helpers_utils_object__WEBPACK_IMPORTED_MODULE_5__/* .pick */ .e)(_types__WEBPACK_IMPORTED_MODULE_4__/* .SIZES */ .zf, "sm", "md", "lg", "xl", "2xl");
var FONT_OPTIONS = (0,_helpers_utils_object__WEBPACK_IMPORTED_MODULE_5__/* .pick */ .e)(_types__WEBPACK_IMPORTED_MODULE_4__/* .FONTS */ .g5, "heading", "sans", "mono");
var alignClasses = {
    auto: "",
    left: "text-left",
    center: "text-center mx-auto",
    right: "text-right ml-auto"
};
var sizeClasses = {
    sm: "prose-sm md:prose-md",
    md: "prose-md md:prose-base",
    lg: "prose-lg md:prose-xl",
    xl: "prose-lg md:prose-2xl",
    "2xl": "prose-lg md:prose-2xl xl:prose-3xl"
};
var fontClasses = {
    sans: "font-sans",
    mono: "font-mono",
    heading: "font-sans"
};
var Text = function(param) {
    var children = param.children, _as = param.as, as = _as === void 0 ? "div" : _as, background = param.background, color = param.color, _align = param.align, align = _align === void 0 ? "left" : _align, _size = param.size, size = _size === void 0 ? "lg" : _size, className = param.className, _font = param.font, font = _font === void 0 ? "sans" : _font;
    var Element = as;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Element, {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("break-words prose font-regular leading-relaxed", "prose-strong:font-bold prose-strong:text-current", "prose-a:underline prose-a:underline-offset-4", alignClasses[align], sizeClasses[size], fontClasses[font], color ? _colors__WEBPACK_IMPORTED_MODULE_3__/* .textClasses */ .Gb[color] : background ? _colors__WEBPACK_IMPORTED_MODULE_3__/* .proseClasses */ .fh[background] : "text-current", (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, "prose-a:text-action-base", !background || background === "white" || background === "neutral-95")),
            children: children
        })
    });
};
var TextMemo = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.memo(Text)));


/***/ }),

/***/ 37794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* binding */ Title; }
/* harmony export */ });
/* unused harmony exports SIZE_OPTIONS, WEIGHT_OPTIONS, TitleMemo */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67573);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51123);
/* harmony import */ var _helpers_utils_object__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21236);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23302);







var SIZE_OPTIONS = (0,_helpers_utils_object__WEBPACK_IMPORTED_MODULE_5__/* .pick */ .e)(_types__WEBPACK_IMPORTED_MODULE_4__/* .SIZES */ .zf, "xs", "sm", "md", "lg", "xl", "2xl", "3xl", "4xl");
var WEIGHT_OPTIONS = (0,_helpers_utils_object__WEBPACK_IMPORTED_MODULE_5__/* .pick */ .e)(_types__WEBPACK_IMPORTED_MODULE_4__/* .FONT_WEIGHTS */ .Xw, "book", "bold");
var sizeClasses = {
    xs: "text-title-xs-sm md:text-title-xs-md lg:text-title-xs-lg",
    sm: "text-title-sm-sm md:text-title-sm-md lg:text-title-sm-lg",
    md: "text-title-md-sm md:text-title-md-md lg:text-title-md-lg",
    lg: "text-title-lg-sm md:text-title-lg-md lg:text-title-lg-lg",
    xl: "text-title-xl-sm md:text-title-xl-md lg:text-title-xl-lg",
    "2xl": "text-title-2xl-sm md:text-title-2xl-md lg:text-title-2xl-lg",
    "3xl": "text-title-3xl-sm md:text-title-3xl-md lg:text-title-3xl-lg",
    "4xl": "text-title-4xl-sm md:text-title-4xl-md lg:text-title-4xl-lg"
};
var weightClasses = {
    book: "font-book",
    bold: "font-bold"
};
var Title = function(param) {
    var children = param.children, _as = param.as, as = _as === void 0 ? "h2" : _as, _size = param.size, size = _size === void 0 ? "sm" : _size, _weight = param.weight, weight = _weight === void 0 ? "bold" : _weight, className = param.className, _color = param.color, color = _color === void 0 ? "neutral-base" : _color, eyebrow = param.eyebrow, _eyebrowColor = param.eyebrowColor, eyebrowColor = _eyebrowColor === void 0 ? "brand-base" : _eyebrowColor;
    var ref;
    var Element = as;
    var titleWords = (ref = children === null || children === void 0 ? void 0 : children.toString()) === null || ref === void 0 ? void 0 : ref.trim().split(" ");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            eyebrow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("block mb-[.5em]", sizeClasses.md, _colors__WEBPACK_IMPORTED_MODULE_3__/* .textClasses */ .Gb[eyebrowColor], (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, "opacity-75", eyebrowColor === "white")),
                children: [
                    eyebrow,
                    "\xa0"
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Element, {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("break-words inline-block", "font-sans", "flex flex-col whitespace-pre-line", _colors__WEBPACK_IMPORTED_MODULE_3__/* .textClasses */ .Gb[color], sizeClasses[size], weightClasses[weight], className),
                children: typeof children === "string" ? titleWords.join(" ") : children
            })
        ]
    });
};
var TitleMemo = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.memo(Title)));


/***/ }),

/***/ 18921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CardGrid": function() { return /* binding */ CardGrid; },
  "default": function() { return /* binding */ CardGrid_CardGrid; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(67573);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/Decorations/Lozenge.tsx
var Lozenge = __webpack_require__(12433);
// EXTERNAL MODULE: ./components/Decorations/One.tsx
var One = __webpack_require__(7693);
// EXTERNAL MODULE: ./components/Slider/Slider.tsx
var Slider = __webpack_require__(20034);
// EXTERNAL MODULE: ./components/buttons/ButtonGroup.tsx
var ButtonGroup = __webpack_require__(12901);
// EXTERNAL MODULE: ./components/module/Text.tsx
var Text = __webpack_require__(55237);
// EXTERNAL MODULE: ./components/module/Title.tsx
var Title = __webpack_require__(37794);
// EXTERNAL MODULE: ./components/module/Wrapper.tsx
var Wrapper = __webpack_require__(83118);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(69779);
;// CONCATENATED MODULE: ./helpers/utils/array.ts

function shuffle(arr) {
    var newArr = (0,_to_consumable_array/* default */.Z)(arr);
    return newArr.map(function(value) {
        return {
            value: value,
            sort: Math.random()
        };
    }).sort(function(a, b) {
        return a.sort - b.sort;
    }).map(function(param) {
        var value = param.value;
        return value;
    });
}

// EXTERNAL MODULE: ./hooks/useBreakpoint.ts
var useBreakpoint = __webpack_require__(43069);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(75815);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(55577);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_create_super.mjs + 5 modules
var _create_super = __webpack_require__(84737);
;// CONCATENATED MODULE: ./layout/ModuleBuilder/ErrorBoundary.tsx





var IS_PRODUCTION = "production" === "production";
var ErrorBoundary = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ErrorBoundary, Component);
    var _super = (0,_create_super/* default */.Z)(ErrorBoundary);
    function ErrorBoundary(props) {
        (0,_class_call_check/* default */.Z)(this, ErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            hasError: false,
            error: null
        };
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
        console.error("Uncaught error:", error, errorInfo);
    };
    _proto.render = function render() {
        if (this.state.hasError) {
            if (IS_PRODUCTION) return null;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-white p-10 rounded-xl",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: this.state.error.toString()
                })
            });
        }
        return this.props.children;
    };
    ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true,
            error: error
        };
    };
    return ErrorBoundary;
}(react.Component);
/* harmony default export */ var ModuleBuilder_ErrorBoundary = (ErrorBoundary);

;// CONCATENATED MODULE: ./modules/CardGrid/CardGrid.classes.tsx
var gridClasses = {
    1: "grid-cols-1",
    2: "sm:grid-cols-2",
    3: "sm:grid-cols-2 lg:grid-cols-3",
    4: "sm:grid-cols-2 lg:grid-cols-4"
};
// css grid doesn't have centering abilities for left over
// child items. Using nth child selectors and translates combined
// with col-start we can achieve that effect.
//
// created a tailwind pen https://play.tailwindcss.com/f9vDSGiuvA
// see GridCenterCards in Storybook for a test case
//
// There's no need to center below medium breakpoint because the other
// module items (title, intro etc) are left aligned on mobile.
var gridCenterClasses = {
    1: "",
    2: "md:[&>*:last-child:nth-child(2n-1)]:translate-x-1/2",
    3: "md:max-lg:[&>*:last-child:nth-child(2n-1)]:translate-x-1/2 \n    lg:[&>*:last-child:nth-child(2n-1)]:translate-x-none\n    lg:[&>*:last-child:nth-child(3n-1)]:col-start-3 \n    lg:[&>*:last-child:nth-child(3n-1)]:-translate-x-1/2 \n    lg:[&>*:nth-last-child(2):nth-child(3n+1)]:col-start-2 \n    lg:[&>*:nth-last-child(2):nth-child(3n+1)]:-translate-x-1/2 \n    lg:[&>*:last-child:nth-child(3n-2)]:col-start-2".replace(/\n/g, ""),
    4: "md:max-lg:[&>*:last-child:nth-child(2n-1)]:translate-x-1/2 \n    lg:[&>*:last-child:nth-child(4n-1)]:translate-x-1/2 \n    lg:[&>*:nth-last-child(2):nth-child(4n+2)]:translate-x-1/2 \n    lg:[&>*:nth-last-child(3):nth-child(4n+1)]:translate-x-1/2\n    lg:[&>*:nth-last-child(2):nth-child(4n+1)]:col-start-2\n    lg:[&>*:nth-last-child(1):nth-child(4n+1)]:col-start-3 \n    lg:[&>*:nth-last-child(1):nth-child(4n+1)]:-translate-x-1/2\n  ".replace(/\n/g, "")
};
// need all breakpoints defined in these classes to calculate the slider gap
var gapHorizontalClasses = {
    none: "gap-x-0",
    xs: "gap-x-3 sm:gap-x-4 md:gap-x-6 lg:gap-x-6 xl:gap-x-6 2xl:gap-x-6",
    sm: "gap-x-4 sm:gap-x-4 md:gap-x-4 lg:gap-x-8 xl:gap-x-8 2xl:gap-x-8",
    md: "gap-x-5 sm:gap-x-5 md:gap-x-6 lg:gap-x-10 xl:gap-x-10 2xl:gap-x-10",
    lg: "gap-x-6 sm:gap-x-6 md:gap-x-10 lg:gap-x-16 xl:gap-x-20 2xl:gap-x-22",
    xl: "gap-x-10 sm:gap-x-10 md:gap-x-20 lg:gap-x-24 xl:gap-x-32 2xl:gap-x-40"
};
var gapVerticalClasses = {
    none: "gap-y-0",
    xs: "gap-y-3 sm:gap-y-4 md:gap-y-6 lg:gap-y-6 xl:gap-y-6 2xl:gap-y-6",
    sm: "gap-y-4 sm:gap-y-4 md:gap-y-4 lg:gap-y-8 xl:gap-y-8 2xl:gap-y-8",
    md: "gap-y-5 sm:gap-y-5 md:gap-y-6 lg:gap-y-10 xl:gap-y-10 2xl:gap-y-10",
    lg: "gap-y-8 sm:gap-y-8 md:gap-y-10 lg:gap-y-16 xl:gap-y-20 2xl:gap-y-24",
    xl: "gap-y-10 sm:gap-y-10 md:gap-y-20 lg:gap-y-24 xl:gap-y-32 2xl:gap-y-40"
};

;// CONCATENATED MODULE: ./modules/CardGrid/CardGrid.tsx



















var ComposableCard = dynamic_default()(function() {
    return Promise.all(/* import() | ComposableCard */[__webpack_require__.e(843), __webpack_require__.e(452)]).then(__webpack_require__.bind(__webpack_require__, 76006));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76006)
            ];
        }
    },
    suspense: false
});
var ImageCard = dynamic_default()(function() {
    return Promise.all(/* import() | ImageCard */[__webpack_require__.e(843), __webpack_require__.e(437), __webpack_require__.e(893)]).then(__webpack_require__.bind(__webpack_require__, 51063));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51063)
            ];
        }
    },
    suspense: false
});
var CardGrid = function(param) {
    var eyebrow = param.eyebrow, title = param.title, intro = param.intro, items = param.items, buttons = param.buttons, theme = param.theme, feed = param.feed;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38;
    var ref39 = (0,useBreakpoint/* useBreakpoint */.G)(), screenWidth = ref39.screenWidth, breakpoint = ref39.breakpoint;
    var slideColumns = 1;
    if (screenWidth > useBreakpoint/* BREAKPOINTS.xs */.j.xs) slideColumns = 1;
    if (screenWidth > useBreakpoint/* BREAKPOINTS.sm */.j.sm) slideColumns = (items === null || items === void 0 ? void 0 : items.length) === 1 ? 1 : 2;
    if (screenWidth > useBreakpoint/* BREAKPOINTS.md */.j.md) slideColumns = (theme === null || theme === void 0 ? void 0 : (ref = theme.grid) === null || ref === void 0 ? void 0 : ref.columns) < 3 ? theme === null || theme === void 0 ? void 0 : (ref1 = theme.grid) === null || ref1 === void 0 ? void 0 : ref1.columns : 3;
    if (screenWidth > useBreakpoint/* BREAKPOINTS.lg */.j.lg) slideColumns = (theme === null || theme === void 0 ? void 0 : (ref2 = theme.grid) === null || ref2 === void 0 ? void 0 : ref2.columns) || 3;
    // show half of an extra slide if needed
    if ((items === null || items === void 0 ? void 0 : items.length) > slideColumns) {
        slideColumns = +slideColumns + (screenWidth > useBreakpoint/* BREAKPOINTS.md */.j.md ? 0.25 : 0.5);
    }
    // slider on mobile by default, adjustable by theme
    var slider = false;
    if (screenWidth < useBreakpoint/* BREAKPOINTS.lg */.j.lg && (theme === null || theme === void 0 ? void 0 : (ref3 = theme.slider) === null || ref3 === void 0 ? void 0 : ref3.mobile) !== false) slider = true;
    if (screenWidth > useBreakpoint/* BREAKPOINTS.lg */.j.lg && (theme === null || theme === void 0 ? void 0 : (ref4 = theme.slider) === null || ref4 === void 0 ? void 0 : ref4.desktop) === true) slider = true;
    if ((items === null || items === void 0 ? void 0 : items.length) === 1) slider = false;
    if (+(theme === null || theme === void 0 ? void 0 : (ref5 = theme.grid) === null || ref5 === void 0 ? void 0 : ref5.columns) === 1) theme.grid.stagger = false;
    // purple background scenario: change overal colouring
    var titleColor = "neutral-base";
    var textColor = "neutral-25";
    var eyebrowColor = "brand-base";
    if ((theme === null || theme === void 0 ? void 0 : (ref6 = theme.module) === null || ref6 === void 0 ? void 0 : ref6.background) === "brand-dark") {
        titleColor = "white";
        textColor = "white";
        eyebrowColor = "brand-light";
    }
    // work out any custom ordering
    var orderRandom = function(items) {
        return shuffle(items);
    };
    var orderAlphabetical = function(items) {
        return items === null || items === void 0 ? void 0 : items.sort(function(a, b) {
            if (a.type === "card.composable" && b.type === "card.composable") {
                return a.title.localeCompare(b.title);
            }
            return 0;
        });
    };
    var orderByDate = function(items) {
        return items === null || items === void 0 ? void 0 : items.sort(function(a, b) {
            if (a.type === "card.composable" && b.type === "card.composable") {
                return new Date(a.date).valueOf() - new Date(b.date).valueOf();
            }
            return 0;
        });
    };
    var orderedItems = items;
    if ((theme === null || theme === void 0 ? void 0 : (ref7 = theme.feed) === null || ref7 === void 0 ? void 0 : ref7.ordering) === "alphabetical") {
        orderedItems = orderAlphabetical(items);
    }
    if ((theme === null || theme === void 0 ? void 0 : (ref8 = theme.feed) === null || ref8 === void 0 ? void 0 : ref8.ordering) === "random") {
        orderedItems = orderRandom(items);
    }
    if ((theme === null || theme === void 0 ? void 0 : (ref9 = theme.feed) === null || ref9 === void 0 ? void 0 : ref9.ordering) === "date-asc") {
        orderedItems = orderByDate(items);
    }
    if ((theme === null || theme === void 0 ? void 0 : (ref10 = theme.feed) === null || ref10 === void 0 ? void 0 : ref10.ordering) === "date-desc") {
        orderedItems = orderByDate(items).reverse();
    }
    // read the gap size from the tailwind classes to make grid gaps stay in sync between slider and grid layouts
    var sliderGapSize = getSliderGapSize(breakpoint, (theme === null || theme === void 0 ? void 0 : (ref11 = theme.grid) === null || ref11 === void 0 ? void 0 : ref11.gapHorizontal) || "xs");
    var hasContentBeforeGrid = title || intro || Boolean(buttons === null || buttons === void 0 ? void 0 : buttons.length) && (theme === null || theme === void 0 ? void 0 : (ref12 = theme.buttons) === null || ref12 === void 0 ? void 0 : ref12.position) !== "after";
    var _obj, _obj1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "overflow-hidden relative",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper/* Wrapper */.i, {
            id: title,
            theme: {
                background: theme === null || theme === void 0 ? void 0 : (ref13 = theme.module) === null || ref13 === void 0 ? void 0 : ref13.background,
                space: theme === null || theme === void 0 ? void 0 : (ref14 = theme.module) === null || ref14 === void 0 ? void 0 : ref14.space,
                rounded: {
                    top: theme === null || theme === void 0 ? void 0 : (ref15 = theme.decorations) === null || ref15 === void 0 ? void 0 : ref15.roundedTop,
                    bottom: theme === null || theme === void 0 ? void 0 : (ref16 = theme.decorations) === null || ref16 === void 0 ? void 0 : ref16.roundedBottom
                }
            },
            innerClassName: "overflow-hidden",
            children: [
                (theme === null || theme === void 0 ? void 0 : (ref17 = theme.decorations) === null || ref17 === void 0 ? void 0 : ref17.showOnes) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "absolute inset-0 hidden md:block pointer-events-none ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(One/* One */.f, {
                            direction: "up",
                            color: "brand-base",
                            className: "absolute left-0 -top-9 scale-75 xl:scale-100 -translate-x-[95%] xl:-translate-x-[100%] 2xl:-translate-x-[77%] rotate-[25.4deg]"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(One/* One */.f, {
                            direction: "down",
                            color: "brand-base",
                            className: "absolute right-0 top-0 scale-75 xl:scale-100 translate-x-[95%] -translate-y-[60%] xl:translate-x-[100%] 2xl:translate-x-[88%] xl:-translate-y-[52%]"
                        })
                    ]
                }),
                (theme === null || theme === void 0 ? void 0 : (ref18 = theme.decorations) === null || ref18 === void 0 ? void 0 : ref18.showLozenges) && (!(theme === null || theme === void 0 ? void 0 : (ref19 = theme.grid) === null || ref19 === void 0 ? void 0 : ref19.stagger) || screenWidth < useBreakpoint/* BREAKPOINTS.lg */.j.lg) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "absolute inset-0 pointer-events-none overflow-hidden",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Lozenge/* Lozenge */.OD, {
                            color: (theme === null || theme === void 0 ? void 0 : (ref20 = theme.module) === null || ref20 === void 0 ? void 0 : ref20.background) === "neutral-95" ? "white" : "neutral-95",
                            size: "lg",
                            rotation: 11,
                            className: classnames_default()("absolute right-0 md:right-[10%] top-0 md:top-[10%]", (0,_define_property/* default */.Z)({}, "opacity-10", (theme === null || theme === void 0 ? void 0 : (ref21 = theme.module) === null || ref21 === void 0 ? void 0 : ref21.background) === "brand-dark"))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Lozenge/* Lozenge */.OD, {
                            color: (theme === null || theme === void 0 ? void 0 : (ref22 = theme.module) === null || ref22 === void 0 ? void 0 : ref22.background) === "brand-dark" ? "white" : "blue-light",
                            size: "md",
                            rotation: 2,
                            className: "absolute hidden md:block left-[10%] top-[50%]"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Lozenge/* Lozenge */.OD, {
                            color: "brand-light",
                            size: "sm",
                            rotation: 10,
                            className: "absolute right-[30%] bottom-0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("z-20 relative", (0,_define_property/* default */.Z)({}, "py-8 sm:py-10 lg:py-16 xl:py-30", theme === null || theme === void 0 ? void 0 : (ref23 = theme.module) === null || ref23 === void 0 ? void 0 : ref23.background)),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()("max-w-title flex flex-col gap-8", (_obj = {}, (0,_define_property/* default */.Z)(_obj, "md:text-left", (theme === null || theme === void 0 ? void 0 : (ref24 = theme.module) === null || ref24 === void 0 ? void 0 : ref24.align) === "left"), (0,_define_property/* default */.Z)(_obj, "md:text-center md:mx-auto", (theme === null || theme === void 0 ? void 0 : (ref25 = theme.module) === null || ref25 === void 0 ? void 0 : ref25.align) === "center"), (0,_define_property/* default */.Z)(_obj, "md:text-right md:ml-auto", (theme === null || theme === void 0 ? void 0 : (ref26 = theme.module) === null || ref26 === void 0 ? void 0 : ref26.align) === "right"), _obj)),
                            children: [
                                (Boolean(title === null || title === void 0 ? void 0 : title.trim().length) || Boolean(eyebrow === null || eyebrow === void 0 ? void 0 : eyebrow.trim().length)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.Dx, {
                                    size: (theme === null || theme === void 0 ? void 0 : (ref27 = theme.title) === null || ref27 === void 0 ? void 0 : ref27.size) || "3xl",
                                    eyebrow: eyebrow,
                                    color: titleColor,
                                    eyebrowColor: eyebrowColor,
                                    children: title
                                }),
                                intro && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.xv, {
                                    size: "lg",
                                    color: textColor,
                                    as: "div",
                                    align: screenWidth < useBreakpoint/* BREAKPOINTS.md */.j.md ? "left" : (theme === null || theme === void 0 ? void 0 : (ref28 = theme.module) === null || ref28 === void 0 ? void 0 : ref28.align) === "center" ? "center" : (theme === null || theme === void 0 ? void 0 : (ref29 = theme.module) === null || ref29 === void 0 ? void 0 : ref29.align) === "right" ? "right" : "left",
                                    children: intro
                                }),
                                buttons && (theme === null || theme === void 0 ? void 0 : (ref30 = theme.buttons) === null || ref30 === void 0 ? void 0 : ref30.position) !== "after" && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardGridButtons, {
                                    buttons: buttons,
                                    theme: theme
                                })
                            ]
                        }),
                        Boolean(orderedItems === null || orderedItems === void 0 ? void 0 : orderedItems.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("text-left", (0,_define_property/* default */.Z)({}, "mt-10 sm:mt-12 md:mt-16 xl:mt-20", hasContentBeforeGrid)),
                                children: slider ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* Slider */.i, {
                                    gap: sliderGapSize,
                                    columns: slideColumns,
                                    slides: orderedItems === null || orderedItems === void 0 ? void 0 : orderedItems.map(function(item) {
                                        if ((item === null || item === void 0 ? void 0 : item.type) === "card.composable") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardWrapper, {
                                            children: /*#__PURE__*/ (0,react.createElement)(ComposableCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                                key: item._key,
                                                themeName: feed === null || feed === void 0 ? void 0 : feed.type
                                            }))
                                        });
                                        if ((item === null || item === void 0 ? void 0 : item.type) === "card.image") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardWrapper, {
                                            children: /*#__PURE__*/ (0,react.createElement)(ImageCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                                key: item._key
                                            }))
                                        });
                                    }),
                                    controlsColor: theme === null || theme === void 0 ? void 0 : (ref31 = theme.slider) === null || ref31 === void 0 ? void 0 : ref31.color
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()("grid", gridClasses[(theme === null || theme === void 0 ? void 0 : (ref32 = theme.grid) === null || ref32 === void 0 ? void 0 : ref32.columns) || 2], gapHorizontalClasses[(theme === null || theme === void 0 ? void 0 : (ref33 = theme.grid) === null || ref33 === void 0 ? void 0 : ref33.gapHorizontal) || "xs"], gapVerticalClasses[(theme === null || theme === void 0 ? void 0 : (ref34 = theme.grid) === null || ref34 === void 0 ? void 0 : ref34.gapVertical) || "xs"], (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, "pb-20", theme === null || theme === void 0 ? void 0 : (ref35 = theme.grid) === null || ref35 === void 0 ? void 0 : ref35.stagger), (0,_define_property/* default */.Z)(_obj1, gridCenterClasses[theme === null || theme === void 0 ? void 0 : (ref36 = theme.grid) === null || ref36 === void 0 ? void 0 : ref36.columns], (theme === null || theme === void 0 ? void 0 : (ref37 = theme.module) === null || ref37 === void 0 ? void 0 : ref37.align) === "center"), _obj1)),
                                    children: orderedItems === null || orderedItems === void 0 ? void 0 : orderedItems.map(function(item, i) {
                                        var ref, ref1;
                                        var staggerStyle = (theme === null || theme === void 0 ? void 0 : (ref = theme.grid) === null || ref === void 0 ? void 0 : ref.stagger) ? {
                                            transform: "translateY(".concat(80 + i % (Math.floor(slideColumns) || 2) * -80, "px)")
                                        } : null;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "h-full w-full",
                                            style: staggerStyle,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardWrapper, {
                                                children: [
                                                    (item === null || item === void 0 ? void 0 : item.type) === "card.composable" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ComposableCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                                        themeName: feed === null || feed === void 0 ? void 0 : feed.type
                                                    })),
                                                    (item === null || item === void 0 ? void 0 : item.type) === "card.image" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                                        lozengeVariantIndex: (theme === null || theme === void 0 ? void 0 : (ref1 = theme.decorations) === null || ref1 === void 0 ? void 0 : ref1.showLozenges) ? i : null
                                                    }))
                                                ]
                                            })
                                        }, item._key);
                                    })
                                })
                            })
                        }),
                        buttons && (theme === null || theme === void 0 ? void 0 : (ref38 = theme.buttons) === null || ref38 === void 0 ? void 0 : ref38.position) === "after" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((0,_define_property/* default */.Z)({}, "mt-10 md:mt-12 lg:mt-16 xl:mt-20", !slider || !(orderedItems === null || orderedItems === void 0 ? void 0 : orderedItems.length))),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardGridButtons, {
                                buttons: buttons,
                                theme: theme
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var CardGrid_CardGrid = (/*#__PURE__*/react.memo(CardGrid));
var CardGridButtons = function(param) {
    var buttons = param.buttons, theme = param.theme;
    var ref, ref1, ref2, ref3, ref4;
    var screenWidth = (0,useBreakpoint/* useBreakpoint */.G)().screenWidth;
    if (!buttons) return null;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("flex", (_obj = {}, (0,_define_property/* default */.Z)(_obj, "md:justify-start", (theme === null || theme === void 0 ? void 0 : (ref = theme.module) === null || ref === void 0 ? void 0 : ref.align) === "left"), (0,_define_property/* default */.Z)(_obj, "md:justify-center", (theme === null || theme === void 0 ? void 0 : (ref1 = theme.module) === null || ref1 === void 0 ? void 0 : ref1.align) === "center"), (0,_define_property/* default */.Z)(_obj, "md:justify-end", (theme === null || theme === void 0 ? void 0 : (ref2 = theme.module) === null || ref2 === void 0 ? void 0 : ref2.align) === "right"), _obj)),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonGroup/* ButtonGroup */.i, {
            items: buttons,
            stretch: false,
            direction: "horizontal",
            align: // this is needed to control the wrapping of multiple buttons
            screenWidth < useBreakpoint/* BREAKPOINTS.md */.j.md ? "left" : (theme === null || theme === void 0 ? void 0 : (ref3 = theme.module) === null || ref3 === void 0 ? void 0 : ref3.align) === "center" ? "center" : (theme === null || theme === void 0 ? void 0 : (ref4 = theme.module) === null || ref4 === void 0 ? void 0 : ref4.align) === "right" ? "right" : "left"
        })
    });
};
var CardWrapper = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModuleBuilder_ErrorBoundary, {
            children: children
        })
    });
};
var getSliderGapSize = function(breakpoint, gapHorizontal) {
    var sliderGapSizes = gapHorizontalClasses[gapHorizontal].split(" ").reduce(function(acc, curr) {
        var ref;
        var _$breakpoint = ((ref = curr.match(/(.*):/)) === null || ref === void 0 ? void 0 : ref[1]) || "xs";
        var gap = +curr.match(/\d+$/)[0] * 4;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, _$breakpoint, gap));
    }, {});
    return sliderGapSizes[breakpoint];
};


/***/ })

}]);